<h2 class="modal-title" style="margin-top: 3%; margin-left: 65px; font-weight: bold;">
  Modifier utilisateur </h2>
  <hr style="
  border: 1px solid #262756;
  opacity: 0.23;
  top: 247px;
  left: 442px;
  width: 1035px;
  height: 0px;
">
<div class="container-fluid mt-3" style="width: 93%;">
  <form class="mt-4" [formGroup]="registerFormUpdate">
    <div class="row">
      <div class="col-5 col-md-5 w-100">
        <h1 class="mytitle">
          Nom de compte</h1>
          <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
            <mat-label>Nom de compte </mat-label>
            <input [(ngModel)]="username" formControlName="username" #input matInput placeholder="" [(ngModel)]="username" class="inputModal"
              [errorStateMatcher]="matcher" required>
            <mat-error *ngIf="registerFormUpdate.controls['username'].invalid"
              class="elhoo_compte_messageErrorPositionModal">
              Nom de compte est <strong>obligatoire</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
            <mat-label>E-Mail</mat-label>
            <input matInput [(ngModel)]="email" formControlName="email" matInput placeholder="" [(ngModel)]="email" class="inputModal"
              [errorStateMatcher]="matcher" required type="email">

            <mat-error *ngIf="registerFormUpdate.get('email').hasError('email')">Veuillez saisir une format valide !
            </mat-error>

          </mat-form-field>
      </div>
      <div class="col-1 col-md-1 w-100"></div>
      <div class="col-5 col-md-5 w-100">
        <h1 class="mytitle">
          Informations de contact
        </h1>
        <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
          <mat-label>Prénom</mat-label>
          <input matInput [(ngModel)]="first_name" formControlName="first_name" placeholder="" class="inputModal" [errorStateMatcher]="matcher">
        </mat-form-field>

        <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
          <mat-label>Nom</mat-label>
          <input matInput [(ngModel)]="last_name" formControlName="last_name" type="text" class="inputModal" [errorStateMatcher]="matcher"
            required>
          <mat-error *ngIf="registerFormUpdate.controls['last_name'].invalid" class="elhoo_compte_messageErrorPositionModal">
            Nom est <strong>obligatoire</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
          <mat-label>Téléphone</mat-label>
          <input [(ngModel)]="gsm_number"  maxlength="15" type="tel" matInput formControlName="gsm_number" placeholder="" class="inputModal">
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-5 col-md-5 w-100">
        <h1 class="mytitle">
          Localisation </h1>
          <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Sélectionner Pays </mat-label>
            <mat-select formControlName="country" [(ngModel)]="country" class="inputModal" (selectionChange)="onChangeCountry($event)">

              <mat-option *ngFor="let country of countryInfo; let i = index" [value]="i">
                {{country.CountryName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Sélectionner Ville </mat-label>


            <mat-select formControlName="city" [(ngModel)]="city" class="inputModal">

              <mat-option *ngFor="let state of stateInfo; let j = index" [value]="j">{{state.StateName}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill" class="w-100 mb-3">
            <mat-label>Sélectionner Langue</mat-label>
            <mat-select disableRipple formControlName="lang" [(ngModel)]="lang" class="inputModal">
              <mat-option [value]="0">Francais</mat-option>
              <mat-option [value]="1">Anglais</mat-option>
              <mat-option [value]="2">Espagnol</mat-option>
            </mat-select>
          </mat-form-field>
      </div>
      <div class="col-1 col-md-1 w-100" ></div>
      <div class="col-5 col-md-5 w-100">
        <h1 class="mytitle">
          Mot de passe</h1>
          <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
            <mat-label>Mot de passe</mat-label>
            <input #motdepassemodifier minlength="10" maxlength="15" matInput formControlName="password"
              [type]="hide ? 'password' : 'text'" id="password" placeholder="" class="inputModal"
              [errorStateMatcher]="matcher" placeholder="***************">
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide">
              <mat-icon style="color: #3b5876;">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-hint align="start" style="color: green;">Mot de passe entre 10 et 15 caractères </mat-hint>
            <mat-hint align="end" style="color: green;">{{motdepassemodifier.value.length}} / 15</mat-hint>
          </mat-form-field>

          <mat-form-field appearance="fill" class="example-full-width w-100 mb-3">
            <mat-label>Confirmation du mot de passe</mat-label>
            <input minlength="10" maxlength="15" formControlName="passwordConfirm" placeholder="" class="inputModal"
              id="passwordConfirm" [errorStateMatcher]="matcher" [type]="hide2 ? 'password' : 'text'" matInput
              placeholder="***************">
            <button mat-icon-button matSuffix (click)="hide2 = !hide2" [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide2">
              <mat-icon style="color: #3b5876;">{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>


            <mat-error *ngIf="registerFormUpdate.get('passwordConfirm').hasError('confirmedValidator')" class="error-txt">
              Les mots
              de passe doivent être identiques.</mat-error>
          </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-5 col-md-5 w-100">
        <h1 class="mytitle">Accès</h1>
        <mat-form-field color="accent" appearance="fill" class="w-100 mb-3">
          <mat-label>Date d'expiration</mat-label>
          <input matInput [(ngModel)]="expiration_date" [matDatepicker]="picker1" formControlName="expiration_date"
            class="inputModal">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>

<div class="justify-content-end d-flex" style="margin-right: 5%; margin-bottom: 40px;">
  <a  class="savebtn mr-2" type="submit"
    aria-pressed="true" matDialogClose (click)="submitFormUpdate(id) ">Enregistrer</a>
    <a class="cancelbtn" type="button"matDialogClose
    aria-pressed="true">Annuler</a>
</div>
